import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function ClockWidget() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('es', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('es', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  };

  return (
    <div className="flex items-center space-x-4 px-4 py-2 bg-white rounded-lg shadow-sm">
      <Clock className="h-6 w-6 text-primary" />
      <div>
        <p className="text-2xl font-semibold text-gray-900">
          {formatTime(time)}
        </p>
        <p className="text-xs text-gray-500 capitalize">
          {formatDate(time)}
        </p>
      </div>
    </div>
  );
}